/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyEmailRequest
 */
export interface VerifyEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyEmailRequest
     */
    email: string;
}

/**
 * Check if a given object implements the VerifyEmailRequest interface.
 */
export function instanceOfVerifyEmailRequest(value: object): value is VerifyEmailRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function VerifyEmailRequestFromJSON(json: any): VerifyEmailRequest {
    return VerifyEmailRequestFromJSONTyped(json, false);
}

export function VerifyEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function VerifyEmailRequestToJSON(value?: VerifyEmailRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
    };
}

